import { Link, useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Plus } from 'lucide-react'
import { invoicesApi } from '../api/invoices'
import { StatusBadge } from './ui/StatusBadge'

export function ProformasTab({ companyId, refType, refId }: {
  companyId: string
  refType: 'leads' | 'deals'
  refId: string
}) {
  const navigate = useNavigate()
  const filter = refType === 'leads' ? { leadId: refId } : { dealId: refId }
  const { data, isLoading } = useQuery({
    queryKey: ['invoices', companyId, filter],
    queryFn: () => invoicesApi.list(companyId, { ...filter, limit: 50 }),
  })
  const newHref = `/company/${companyId}/invoices/new?${refType === 'leads' ? 'leadId' : 'dealId'}=${refId}`

  return (
    <div className="p-3">
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm text-gray-500">{data?.meta.total ?? 0} proforma(s)</p>
        <button className="btn btn-primary btn-sm" onClick={() => navigate(newHref)}>
          <Plus className="w-4 h-4" /> New proforma
        </button>
      </div>
      {isLoading ? <p className="text-sm text-gray-500">Loading…</p> : (
        <ul className="divide-y">
          {(data?.data ?? []).map(inv => (
            <li key={inv.id} className="py-2 flex items-center justify-between text-sm">
              <Link className="font-mono text-blue-600 hover:underline"
                to={`/company/${companyId}/invoices/${inv.id}/edit`}>{inv.number}</Link>
              <span>{inv.patientName}</span>
              <span>{Number(inv.total).toFixed(2)} {inv.currency}</span>
              <StatusBadge status={inv.status} className="text-xs" />
            </li>
          ))}
          {!data?.data?.length && <li className="py-4 text-center text-gray-400 text-sm">No proformas yet.</li>}
        </ul>
      )}
    </div>
  )
}
